import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useIcons from '@/composables/useIcons'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'StarRating',
  props: {
    rating: {
      required: true,
      type: Number,
    },
    color: {
      type: String,
      default: 'var(--primary-text-color)',
    },
  },
  setup(__props) {

const props = __props;

  

  const { star5Icon } = useIcons()
  const stars = 5

  const ratePercentage = computed(() => {
    return Math.round((props.rating / stars) * 100)
  })

return { __sfc: true,props, star5Icon, stars, ratePercentage, computed, SVGRenderer, useIcons }
}

})